<span ngbDropdown autoClose="outside" placement="bottom-right">
  <button ngbDropdownToggle [disabled]="disabled" type="button" class="dropdown-toggle btn btn-text">
    <svg class="icon-16">
      <use href="../../../App_Themes/clearview-default/icons/utility/export.svg#export"></use>
    </svg>
    <span cvLocalizedText langSection="AgGrid" langKey="export">Export</span>
  </button>
  <ul ngbDropdownMenu class="dropdown-menu dropdown-menu-right" aria-labelledby="simple-dropdown">
    <li *ngFor="let item of itemsToDisplay" role="menuitem" class="dropdown-item export-element cursor-pointer" (click)="onClickDownloadFile(item.format)">
      <svg class="icon-16 fill-valyrianSteel fill-hover-whaleTail" ><use [attr.href]="item.icon"></use></svg>
      <span class="color-theUpsideDown" cvLocalizedText langSection="AgGrid" [langKey]="item.langKey">{{ item.title }}</span>
    </li>
  </ul>
</span>
